import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams, useSearchParams } from "react-router-dom";
import CategoryHeader from "../../Components/Category/CategoryHeader";
import CardProductsContainer from "../../Components/Products/CardProductsContainer";
import Pagination from "../../Components/Utilities/Pagination";
import ProductsResults from "../../Components/Utilities/ProductsResults";
import SideFilter from "../../Components/Utilities/SideFilter";
import ViewAllProductsByCategoryHook from "../../hook/product/ViewAllProductsByCategoryHook";
import ViewAllProductsBySubCategoryHook from "../../hook/product/ViewAllProductsBySubCategoryHook";
import ViewSearchProductHooks from "../../hook/product/ViewSearchProductHooks";

import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import LoadingSpinner from "../../Components/Utilities/LoadingSpinner";

const ProductsBySubCategory = () => {
  const { id } = useParams();
  const [catById] = ViewAllProductsBySubCategoryHook(id);
  // console.log('catById')
  // console.log(catById)
  const [
    items,
    pagination,
    onPress,
    getProduct,
    result,
    offers,
    selectedCategorySearch,
    selectedBrandSearch,
    search,
    onChangeSetMinPrice,
    onChangeSetMaxPrice,
    ,
    ,
    loadingSpinner,
    settingsRes,
    minPrice,
    maxPrice,
    searchBrand
  ] = ViewSearchProductHooks("", id);

  const[searchParams,setSearchParams]=useSearchParams();
  const [waitTime, setWaitTime] = useState(true);

  useEffect(()=>{
        setWaitTime(true);
    
        const timeoutId = setTimeout(() => {
          setWaitTime(false);
          // dispatch(EndWaitTimeForHomePage());
        }, 2000);
    
        clearTimeout(timeoutId);
      },[searchParams]);
  
      setTimeout(() => {
        setWaitTime(false);
        // dispatch(EndWaitTimeForHomePage());
      }, 2000);

 // const settingsRes = useSelector((state) => state.settingsReducers.settings);

  if (pagination) var pageCount = pagination;
  else pageCount = 0;

 //if(pageCount>0) localStorage.setItem('page',pageCount);

 console.log('pagination',pagination);
 

  let hideCategory = true;
  return (
    <div style={{ minHeight: "670px" }}>
      <Helmet>
        <title>
          {`  ${items[0]?.subCategory.nameAr || " "} ${items[0] ? "-" : " "} ${
            settingsRes.data?.titleAr
          }`}{" "}
        </title>
      </Helmet>
      <CategoryHeader />
      <Container className="pt-4 pb-2">
        <div className="d-flex align-items-center" style={{ gap: '20px' }}>
          {catById?.image && (
            <div className="premium-brand-logo">
              <img
                src={catById?.image}
                alt="SubCategory Logo"
              />
            </div>
          )}
          <div>
            <h1 className="premium-page-title">{catById?.nameAr}</h1>
            <p className="premium-page-subtitle text-muted mb-0">تصفح أحدث المنتجات والعروض المميزة</p>
          </div>
        </div>
        <hr className="mt-4 mb-2" style={{ borderColor: "rgba(0,0,0,0.05)" }} />
      </Container>
      <Container>
        <Row className="d-flex justify-content-center">
          <Col md="2" sm="2" className="d-flex ">
            <SideFilter
              props={{
                selectedCategorySearch,
                selectedBrandSearch,
                search,
                onChangeSetMinPrice,
                onChangeSetMaxPrice,
                hideCategory,
                minPrice,
                maxPrice,
                searchBrand
              }}
            />
          </Col>
          <Col md="10" sm="10" xs="12" >
            {loadingSpinner === true ? (
              <LoadingSpinner />
            ) :
            <>
             <div style={{ display: waitTime == true ? 'block' : 'none' }}>
                  <LoadingSpinner />
            </div>
            <div style={{ display: waitTime == true ? 'none' : 'block' }}>
            <CardProductsContainer products={items} title="" btntitle="" />
            </div>
            </>
             
              
            }
          </Col>
        </Row>
        
       {pagination && <Pagination pageCount={pageCount} onPress={onPress} />} 
        
      </Container>
    </div>
  );
};

export default ProductsBySubCategory;
